import React, { useState, useEffect, useContext } from "react";
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress } from "@material-ui/core";
import { HOST_URL, basename, LOCAL_STORAGE_KEY } from "../../../../config";
import axios from "axios";
import { getUserData } from "../../../common/utility/Utils";
import { StoreContext } from "../../../../store/Provider";

const Documents = () => {
  const [loading, setLoading] = useState(false);
  const [documentsData, setDocumentsData] = useState([]);
  const context = useContext(StoreContext);

  useEffect(() => {
    if (context.shipmentId !== "") {
      getDocumentsData();
    }
  }, [context.shipmentId]);

  const getDocumentsData = async () => {
    let data = {};
    setDocumentsData([]);
    setLoading(true);
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        console.log(res);
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };

    const END_POINT = `${HOST_URL}api/v1/DocumentData/${data.user_country_code}/ShipmentDocument/ForwardingShipment/${context.shipmentId}`;
    axios
      .get(END_POINT, {
        headers: header,
      })
      .then((res) => {
        setDocumentsData(res.data);
        setLoading(false);
        console.log("documents   data", { res });
      })
      .catch((err) => {
        console.log(err);
        setDocumentsData([]);
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div className="shipmentdetailslower">
        <div className="loadingClass">
          <CircularProgress size="1.5rem" />
        </div>
      </div>
    );
  }

  console.log("element.length", documentsData.length, documentsData);

  if (documentsData.length === 0) {
    return (
      <div className="shipmentdetailslower">
        <div className="shipmentdetailslowerheader">
          <label>Documents</label>
        </div>
        <div className="shipmentdetailslowerBody">
          <div className="documentdiv">
            <p>No document found.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="shipmentdetailslower">
      <div className="shipmentdetailslowerheader">
        <label>Documents</label>
      </div>
      <div className="shipmentdetailslowerBody">
        {documentsData.map((element) => {
          return (
            <a
              href={`data:application/pdf;base64,${element.ImageData}`}
              download={element.FullName}
              name={element.FullName}
            >
              <div className="documentdiv">
                <img src={`/${basename}/Assets/Images/docx.svg`} />
                <p title={element.TypeName}>{element.TypeName}</p>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default Documents;
